import * as React from 'react';
import styled from 'styled-components';

import DailyMessage from '../organisms/Dashboard/DailyMessage';
import TaskSheetBlock from '../organisms/Dashboard/TaskSheetBlock';
import MonthlySales from '../organisms/Dashboard/MonthlySales';
import ActivePermitsBlock from '../molecules/ActivePermitsBlock';
import MonthlyIncomeChart from '../organisms/Dashboard/MonthlyIncomeChart';

const DashboardBlocks = () => {
  return (
    <Wrapper>
      <ActivePermitsBlock />
      <TaskSheetBlock />
      <DailyMessage />
      <StatsBlock>
        <MonthlySales />
        <MonthlyIncomeChart />
      </StatsBlock>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;

  @media only screen and (max-width: 1150px) {
    gap: 14px;
  }

  @media only screen and (max-width: 540px) {
    gap: 10px;
    margin-bottom: 12px;
  }
`;
const StatsBlock = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 20px;
  align-items: start;
  margin-top: 20px;

  @media only screen and (max-width: 1150px) {
    grid-template-columns: 1fr;
    gap: 14px;
    margin-top: 0;
  }
`;

export default DashboardBlocks;
